module.exports = __webpack_public_path__ + "static/media/TOWER Website - others - coinbase - 23 Dec 2022.f0de36ab.svg";